import { clsx, type ClassValue } from "clsx";

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

export function formatNumber(n: number, digits = 1): string {
  if (n === 0) return "0";
  if (n < 1) return n.toFixed(digits);
  if (n < 100) return n.toFixed(digits).replace(/\.0$/, "");
  return Math.round(n).toString();
}

export function formatVoltage(v: number): string {
  return `${formatNumber(v, 2)} V`;
}

export function formatAmp(a: number): string {
  if (a >= 1000) return `${formatNumber(a / 1000, 1)} kA`;
  if (a !== 0 && Math.abs(a) < 0.1) return `${Number((a * 1000).toPrecision(3))} mA`;
  return `${formatNumber(a, 1)} A`;
}

/** A modeled monitor supply uses the published upper bound, so its label
 * must retain "<" even though the solver budgets the full bound. */
export function formatLiveCurrent(amps: number, monitorSupply: boolean): string {
  if (monitorSupply && amps > 0) return `< ${formatAmp(amps)}`;
  if (amps > 0 && amps < 0.1) return formatAmp(amps);
  return `${amps < 10 ? amps.toFixed(1) : Math.round(amps)} A`;
}

export function formatPercent(p: number): string {
  return `${p.toFixed(1)}%`;
}

export function formatLength(m: number): string {
  if (m < 1) return `${Math.round(m * 100)} cm`;
  return `${formatNumber(m, 1)} m`;
}

export function deepClone<T>(value: T): T {
  return JSON.parse(JSON.stringify(value));
}
